<div class="registrar-dashboard">
  <div class="dashboard-header">
    <div class="header-content">
      <div class="header-left">
        <h1 class="dashboard-title">Registrar Dashboard</h1>
        <p class="dashboard-subtitle">Welcome back, {{ currentUser?.username || 'Registrar' }}</p>
      </div>
      <div class="header-right">
        <div class="academic-info">
          <div class="info-item">
            <i class="fa fa-calendar"></i>
            <span>{{ currentAcademicYear }}</span>
          </div>
          <div class="info-item">
            <i class="fa fa-book"></i>
            <span>{{ currentSemester }}</span>
          </div>
        </div>
        <button class="btn-refresh" (click)="refreshDashboard()" [disabled]="isLoading">
          <i class="fa fa-sync-alt" [class.fa-spin]="isLoading"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Loading Overlay -->
  <div class="loading-overlay" *ngIf="isLoading">
    <div class="spinner"></div>
  </div>

  <!-- Statistics Cards -->
  <div class="stats-grid">
    <div 
      class="stat-card" 
      *ngFor="let card of dashboardCards" 
      [class]="'card-' + card.color"
      (click)="navigateTo(card.route || '')"
      [class.clickable]="card.route"
    >
      <div class="card-icon">
        <i class="fa" [class]="card.icon"></i>
      </div>
      <div class="card-content">
        <h3 class="card-title">{{ card.title }}</h3>
        <div class="card-value">{{ card.value }}</div>
        <div class="card-trend" *ngIf="card.trend">
          <i class="fa" [class.fa-arrow-up]="card.trend.isPositive" [class.fa-arrow-down]="!card.trend.isPositive"></i>
          <span>{{ card.trend.value }}% from last month</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content Grid -->
  <div class="content-grid">
    
    <!-- Quick Actions -->
    <div class="dashboard-section quick-actions-section">
      <div class="section-header">
        <h2 class="section-title">
          <i class="fa fa-bolt"></i>
          Quick Actions
        </h2>
      </div>
      <div class="quick-actions-grid">
        <div 
          class="quick-action-card" 
          *ngFor="let action of quickActions"
          (click)="navigateTo(action.route)"
        >
          <div class="action-icon" [class]="'icon-' + action.color">
            <i class="fa" [class]="action.icon"></i>
          </div>
          <div class="action-content">
            <h3 class="action-title">{{ action.title }}</h3>
            <p class="action-description">{{ action.description }}</p>
          </div>
          <div class="action-arrow">
            <i class="fa fa-chevron-right"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- Recent Activities -->
    <div class="dashboard-section activities-section">
      <div class="section-header">
        <h2 class="section-title">
          <i class="fa fa-history"></i>
          Recent Activities
        </h2>
        <a href="#" class="view-all-link">View All</a>
      </div>
      <div class="activities-list">
        <div 
          class="activity-item" 
          *ngFor="let activity of recentActivities"
        >
          <div class="activity-icon">
            <i class="fa" [class]="getActivityIcon(activity.type)"></i>
          </div>
          <div class="activity-content">
            <div class="activity-header">
              <span class="activity-type">{{ activity.type }}</span>
              <span class="activity-time">{{ formatTimeAgo(activity.timestamp) }}</span>
            </div>
            <p class="activity-description">{{ activity.description }}</p>
            <div class="activity-footer">
              <span class="activity-user">
                <i class="fa fa-user"></i>
                {{ activity.user }}
              </span>
              <span class="activity-status" [class]="getStatusClass(activity.status)">
                <i class="fa" [class]="getStatusIcon(activity.status)"></i>
                {{ activity.status }}
              </span>
            </div>
          </div>
        </div>
        <div class="empty-state" *ngIf="recentActivities.length === 0">
          <i class="fa fa-inbox"></i>
          <p>No recent activities</p>
        </div>
      </div>
    </div>

    <!-- Upcoming Events -->
    <div class="dashboard-section events-section">
      <div class="section-header">
        <h2 class="section-title">
          <i class="fa fa-calendar-alt"></i>
          Upcoming Events
        </h2>
      </div>
      <div class="events-list">
        <div class="event-item" *ngFor="let event of upcomingEvents">
          <div class="event-date">
            <div class="date-day">{{ event.date.getDate() }}</div>
            <div class="date-month">{{ event.date.toLocaleString('default', { month: 'short' }) }}</div>
          </div>
          <div class="event-content">
            <h3 class="event-title">
              <i class="fa" [class]="getEventIcon(event.type)"></i>
              {{ event.title }}
            </h3>
            <p class="event-description">{{ event.description }}</p>
            <span class="event-countdown">{{ getDaysUntil(event.date) }} days remaining</span>
          </div>
        </div>
        <div class="empty-state" *ngIf="upcomingEvents.length === 0">
          <i class="fa fa-calendar-times"></i>
          <p>No upcoming events</p>
        </div>
      </div>
    </div>

    <!-- Enrollment Chart (Placeholder) -->
    <div class="dashboard-section chart-section">
      <div class="section-header">
        <h2 class="section-title">
          <i class="fa fa-chart-line"></i>
          Enrollment Trend
        </h2>
        <div class="chart-actions">
          <button class="btn-chart-filter active">6M</button>
          <button class="btn-chart-filter">1Y</button>
          <button class="btn-chart-filter">All</button>
        </div>
      </div>
      <div class="chart-container">
        <div class="chart-placeholder">
          <i class="fa fa-chart-area"></i>
          <p>Chart visualization area</p>
          <small>Integrate with Chart.js or Recharts for live data</small>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer Actions -->
  <div class="dashboard-footer">
    <button class="btn-footer" (click)="navigateTo('/reports')">
      <i class="fa fa-file-export"></i>
      Export Reports
    </button>
    <button class="btn-footer" (click)="navigateTo('/settings')">
      <i class="fa fa-cog"></i>
      Settings
    </button>
    <button class="btn-footer btn-danger" (click)="logout()">
      <i class="fa fa-sign-out-alt"></i>
      Logout
    </button>
  </div>
</div>
<!-- Debug Information -->
  <div class="diagnostics-panel">
    <h3>Debug Information:</h3>
    <p>Component loaded at: {{ currentTime | date:'medium' }}</p>
    <p>Data initialized: {{ recentActivities.length }} activities loaded</p>
  </div>

   <!-- Footer -->
    <div class="slogin-footer-container">
      <p class="slogin-copyright">AUCDT | UITS © 2025 All rights reserved</p>
    </div>